module.exports = __webpack_public_path__ + "img/btn_detonation_off.5eead8e0.svg";